class CommerceModal {
    constructor() {
        this.modalOpen = false;
        this.init();
    }

    init() {
        this.modalOverlay = document.getElementById('commerce-modal-overlay');
        if (!this.modalOverlay) {
            let tpl = document.getElementById('commerce-modal-template');
            if (tpl) {
                let el = document.createElement('div');
                el.innerHTML = tpl.innerHTML;
                document.body.appendChild(el);
                this.modalOverlay = document.getElementById('commerce-modal-overlay');
            }
        }
        this.modal = document.getElementById('commerce-modal');
        this.modalTitle = document.getElementById('commerce-modal-title');
        this.modalContent = document.getElementById('commerce-modal-content');
        this.modalContainers = document.querySelectorAll('.commerce-container, #commerce-modal, .commerce-productstv');

        //var modalHeight = modalTitle.offsetHeight + modalContent.offsetHeight;
        let that = this;

        this.lastFocus = false;
        this.modalOpen = false;

        for (let i = 0; i < this.modalContainers.length; i++) {
            const modalContainer = this.modalContainers[i];
            let saveAndCloseBtn = false;

            modalContainer.addEventListener('click', function (event) {
                let target = event.target.nodeName === 'A' || event.target.nodeName === 'BUTTON' ? event.target : event.target.parentNode;

                if (target.matches('.commerce-modal-close')) {
                    that.closeModal(event);
                    return;
                }

                // Set a flag if the save and close button was clicked
                saveAndCloseBtn = target.matches('.commerce-modal-save-and-close') ? true : false;

                if (event.ctrlKey || event.metaKey) {
                    return true;
                }

                if (target.matches('.commerce-ajax-modal')) {
                    event.preventDefault();

                    that.modal.classList.add('modal-loading');
                    const link = target.getAttribute('href'),
                        title = target.getAttribute('data-modal-title') || target.innerHTML,
                        opts = {};

                    if (target.getAttribute('data-modal-refresh-on-close')) {
                        opts.refreshOnClose = true;
                    }

                    if (target.matches('.batch-action')) {
                        opts.batchIds = that.getBatchSelections(target);
                        opts.includeParams = true;
                    }

                    that.loadLinkModal.bind(that)(link, title, opts);
                }

            });

            modalContainer.addEventListener('keydown', function (event) {
                if (!event.target.matches('.commerce-ajax-modal')) return true;

                if (event.keyCode === 32) {
                    const link = event.target.getAttribute('href'),
                        title = event.target.getAttribute('data-modal-title') || event.innerHTML;

                    that.loadLinkModal.bind(that)(link, title);
                }
            });

            modalContainer.addEventListener('submit', function (event) {
                if (!event.target.matches('.commerce-ajax-form')) return true;

                // If the user did a ctrl/cmd+click, let them use normal browser behaviour
                if (event.ctrlKey || event.metaKey) {
                    return true;
                }

                that.modal.classList.add('modal-loading');

                event.preventDefault();

                let formData = new FormData(event.target);
                formData = that.collateTranslations(event.target, formData);

                const link = event.target.getAttribute('action'),
                    data = formData,
                    title = event.target.getAttribute('data-modal-title') || this.innerHTML;

                new Promise(function (resolve, reject) {
                    function reqListener() {
                        resolve(this.responseText);
                    }

                    function reqError(err) {
                        reject(err);
                    }

                    let oReq = new XMLHttpRequest();
                    oReq.onload = reqListener;
                    oReq.onerror = reqError;

                    oReq.open('post', link, true);
                    oReq.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                    oReq.send(data);
                }).then((response) => {
                    if (that._successCallback && response[0] === '{') {

                        try {
                            // Attempt to parse the JSON and feed it back into the callback
                            response = JSON.parse(response);

                            // Run the callback to determine if the submit was successful
                            let submitSuccess = that._successCallback(response);

                            // If save and close button was pressed, close on success
                            if (saveAndCloseBtn && submitSuccess) {
                                that.closeModal.bind(that)();
                            }
                            // otherwise, update the modal
                            else {
                                that.openModal.bind(that)(response.html);
                            }
                        }
                        catch (e) {
                            console.error('Failure decoding JSON response or processing callback', e);
                        }
                    }
                    else {
                        // For a non-json response, attempt to detect a success message and close modal
                        if (saveAndCloseBtn && response.includes('data-response-success="true"')) {
                            that.closeModal.bind(that)();
                        }
                        else {
                            that.openModal.bind(that)(response);
                        }
                    }
                }).catch((error) => (
                    console.error('uh oh', error)
                ));

            }); // end submit listener

        } // end for

        function restrictFocus(event) {
            if (that.modalOpen && !that.modal.contains(event.target)) {
                event.stopPropagation();
                that.modal.focus();
            }
        }

        this.modalOverlay.addEventListener('click', (event) => {
            if (event.target == that.modal.parentNode) {
                that.closeModal.bind(this)(event);
            }
        }, false);

        document.addEventListener('keydown', this.closeModalOnKeydown.bind(this)); // be careful if there are inputs in the modal

        const allNodes = document.querySelectorAll("*");
        for (let i = 0; i < allNodes.length; i++) {
            allNodes.item(i).addEventListener('focus', restrictFocus);
        }
    }

    collateTranslations(form, formData) {
        let tFieldObj = {},
            tFields = form.querySelectorAll('.c-translatable-field');

        if (tFields.length < 1) {
            return formData;
        }

        tFields.forEach(function (tField) {
            let lang = tField.dataset.lang,
                name = tField.dataset.name,
                langObj = {};

            if (typeof tFieldObj[name] === 'undefined') {
                tFieldObj[name] = {};
            }

            if (typeof tFieldObj[name][lang] === 'undefined') {
                tFieldObj[name][lang] = {};
            }
            tFieldObj[name][lang] = tField.value;

            // Cleanup the now unneeded translatable field from the form data
            formData.delete(tField.name);
        });

        // Add the collated translation values to the o.g. fields
        for (const [key, value] of Object.entries(tFieldObj)) {
            formData.set(key, JSON.stringify(value));
        }

        return formData;
    }

    getBatchSelections(target) {
        const ids = [];
        const grid = target.closest('.commerce-grid');
        const checkboxes = grid.querySelectorAll('.commerce-grid-checkbox');
        checkboxes.forEach((checkbox) => {
            if (checkbox.checked === true) {
                ids.push(checkbox.dataset.id);
            }
        });
        return ids;
    }

    loadLinkModal(link, title, modalOpts) {
        modalOpts = modalOpts || {};
        this.lastFocus = document.activeElement;
        this.openLoadingModal({
            title: title
        });
        let that = this;

        new Promise(function (resolve, reject) {
            function reqListener() {
                resolve(this.responseText);
            }

            function reqError(err) {
                reject(err);
            }

            let oReq = new XMLHttpRequest();
            oReq.onload = reqListener;
            oReq.onerror = reqError;

            // Format and add params to request if modalOpts.includeParams is set.
            let url = `${link}&_commerce_ajax=1`;
            if (modalOpts.includeParams) {
                let params = '';
                for (const [key, value] of Object.entries(modalOpts)) {
                    params += `&${key}=${value}`;
                }
                url = `${link}&_commerce_ajax=1${params}`;
            }
            oReq.open('get', url, true);
            oReq.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

            oReq.send();
        }).then((response) => (
            that.openModal.bind(that)(response, modalOpts)
        ));
    }

    openLoadingModal(opts) {
        opts = opts || {};
        this.modalContent.innerHTML = '';
        this.modalOverlay.setAttribute('aria-hidden', 'false');
        this.modalOpen = true;
        this.modal.setAttribute('tabindex', '0');
        this.modal.focus();
        this.modal.classList.add('modal-loading');

        this.modalTitle.innerText = opts.loadingText || 'Loading...';
        this.setModalHeight();
    }

    openModal(response, opts) {
        opts = opts || {};
        this.modalContent.innerHTML = '';
        let range = document.createRange(),
            node = range.createContextualFragment(response);
        while (node.firstChild) {
            this.modalContent.appendChild(node.firstChild);
        }
        if (opts.successCallback) {
            this._successCallback = opts.successCallback;
        }
        if (opts.refreshOnClose) {
            this._refreshOnClose = true;
        }
        if (this._successCallback) {
            let form = this.modalContent.querySelector('form');
            if (form) {
                let returnData = document.createElement('input');
                returnData.type = 'hidden';
                returnData.name = '_returnData';
                returnData.value = '1';
                form.appendChild(returnData);
            }
        }
        this.modalOverlay.setAttribute('aria-hidden', 'false');
        this.modalOpen = true; // NOTE: consider hiding everything else from screen readers karl groves style
        this.modal.setAttribute('tabindex', '0');
        this.modal.focus();
        this.modal.classList.remove('modal-loading');

        let title = this.modalContent.querySelector('.commerce-section-header h3');
        if (title && title.innerText.length > 0) {
            this.modalTitle.innerText = title.innerText;
            title.remove();
        }

        // Set modal height so scrollbar and modal footer can be positioned properly
        this.setModalHeight();

        // Listen to changes for updating the height
        this.modal.addEventListener('change', function(event) {
            if (this.modal.contains(event.target)) {
                this.setModalHeight();
            }
        }.bind(this));

        // Initiate grids inside the modal
        let grids = this.modal.querySelectorAll('.commerce-grid');
        if (grids.length > 0) {
            Commerce.Grid.initGrids(grids, Commerce.Grid);
        }
        // Enhanced special field types in the modal
        Commerce.Fields.enhanceAll(this.modal);

        // Set modal height again after fields are enhanced
        this.setModalHeight();
        // Scroll the overlay to the top so the start of the modal is in view
        if (Element.prototype.hasOwnProperty('scrollTo')) {
            this.modalOverlay.scrollTo({top: 0});
        }

        // Resize the commerce container (which also includes the modal container) to ensure scrollability
        Commerce.resizeContainer();
    }

    // Reloads a form in the response into the same modal dom (keeping the layout)
    reloadModalForm(dom, response) {
        let formWidget = Commerce.Modal.modalContent.querySelector('.commerce-form-widget'),
            range = document.createRange(),
            node = range.createContextualFragment(response);

        formWidget.innerHTML = '';
        while (node.firstChild) {
            formWidget.appendChild(node.firstChild);
        }
        Commerce.Fields.enhanceAll(dom);
        dom.classList.remove('modal-loading');
        Commerce.resizeContainer();
    }

    setModalHeight() {
        this.modal.setAttribute('style', 'height: ' + (this.modalTitle.offsetHeight + this.modalContent.scrollHeight) + 'px;');
    }

    callback(id) {
        let data = {
            id: id,
        };
        if (this._successCallback) {
            if (this._successCallback(data) === true) {
                this.closeModal();
            }
        }
        else {
            alert('Oops, no callback specified. ID: ' + id);
        }
    }

    closeModalOnKeydown(event) {
        event = event || window.event;
        if (!this.modalOpen) {
            return;
        }

        let escape = false;
        if ("key" in event) {
            escape = event.key === "Escape" || event.key === "Esc";
        }
        else if (event.keyCode === 27) {
            escape = true;
        }

        if (escape) {
            this.closeModal();
        }
    }

    closeModal() {
        if (this._refreshOnClose) {
            Commerce.Navigation.refresh();
            this._refreshOnClose = false;
        }
        this._successCallback = false;
        this.modal.setAttribute('tabindex', '-1');
        this.modalOverlay.setAttribute('aria-hidden', 'true');
        this.modalContent.innerHTML = null;
        this.modalOpen = false;
        if (this.lastFocus) {
            this.lastFocus.focus();
        }

        // Refresh all grids on the page, as data may have changed in the modal
        let gridFilters = document.querySelectorAll('.commerce-grid form.commerce-grid-toolbar');
        for (let i = 0; i < gridFilters.length; i++) {
            Commerce.Grid.submitToolbarForm(gridFilters[i]);
        }
    }
}
